/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_RevokedInputs */

const es_co2_error_invitation_revoked = /** @type {(inputs: Error_Invitation_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta invitación fue revocada.`)
};

/**

* @param {Error_Invitation_RevokedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_invitation_revoked = /** @type {((inputs?: Error_Invitation_RevokedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_RevokedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_invitation_revoked(inputs)
});